import { n as isDesignModeActive, r as isPreviewModeActive } from "./modeDetection.js";
import React, { Suspense, createContext, lazy, useContext, useMemo } from "react";
import { Fragment, jsx } from "react/jsx-runtime";

//#region src/design/react/core/PageDesignerProvider.tsx
const LazyDesignProvider = lazy(() => import("./DesignContext3.js").then((module) => ({ default: module.DesignProvider })));
const LazyPreviewProvider = lazy(() => import("./PreviewContext.js").then((module) => ({ default: module.PreviewProvider })));
const LoadingFallback = () => null;
const PageDesignerContext = createContext({
	isDesignMode: false,
	isPreviewMode: false
});
const usePageDesignerMode = () => useContext(PageDesignerContext);
const PageDesignerProvider = ({ children, targetOrigin, clientId, usid, pageUpdateMode, clientLogger, clientConnectionTimeout, clientConnectionInterval, mode }) => {
	const contextValue = useMemo(() => ({
		isDesignMode: mode === "EDIT" || isDesignModeActive(),
		isPreviewMode: mode === "PREVIEW" || isPreviewModeActive()
	}), [mode]);
	const { isDesignMode, isPreviewMode } = contextValue;
	if (isDesignMode && !targetOrigin) throw new Error("PageDesignerProvider: targetOrigin is required when in design mode for security reasons. This should be the origin of the host application that contains this iframe ");
	if (!isDesignMode && !isPreviewMode) return /* @__PURE__ */ jsx(Fragment, { children });
	let content = children;
	if (isPreviewMode) content = /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(LoadingFallback, {}),
		children: /* @__PURE__ */ jsx(LazyPreviewProvider, { children: content })
	});
	if (isDesignMode) content = /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(LoadingFallback, {}),
		children: /* @__PURE__ */ jsx(LazyDesignProvider, {
			targetOrigin,
			clientId,
			usid,
			pageUpdateMode,
			clientLogger,
			clientConnectionTimeout,
			clientConnectionInterval,
			children: content
		})
	});
	return /* @__PURE__ */ jsx(PageDesignerContext.Provider, {
		value: contextValue,
		children: content
	});
};
PageDesignerProvider.defaultProps = {
	clientConnectionTimeout: 6e4,
	clientConnectionInterval: 1e3,
	mode: void 0,
	clientLogger: () => {}
};

//#endregion
//#region src/design/react/core/DesignContext.tsx
const DesignContext = React.createContext(null);
const useDesignContext = () => React.useContext(DesignContext);

//#endregion
export { usePageDesignerMode as i, useDesignContext as n, PageDesignerProvider as r, DesignContext as t };
//# sourceMappingURL=DesignContext2.js.map